import React, {useState} from 'react';
import {
  Alert,
  Image,
  ImageBackground,
  Linking,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import {styles} from './styles';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import {useNavigation} from '@react-navigation/native';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import CheckBox from '../../../../components/CheckBox/CheckBox';
import Input from '../../../../components/Input/Input';
import {Images} from '../../../../constants/Images';
import {useRegisterStore} from '../../../../store/RegisterStore';
import {RegisterDataType} from '../../../../types/Auth';
import {Colors} from '../../../../constants/Colors';
import AuthService from '../../../../services/AuthService/AuthService';
import {NavigationProps} from '../../../../navigation/Routes';
import {AppRoutes} from '../../../../navigation/Routes.types';
import {useLoadingStore} from '../../../../store/LoadingStore';

const RegisterCode = () => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {showLoading, hideLoading} = useLoadingStore();

  const {setRegisterData} = useRegisterStore();

  const [check, setCheck] = useState<boolean>(false);

  const [credentials, setCredentials] = useState<RegisterDataType>({
    clientCode: '',
    cpfCnpj: '',
  });

  const handleNavigateRegisterForm = async () => {
    showLoading();
    try {
      const response = await AuthService.postRegister(
        credentials.clientCode,
        credentials.cpfCnpj,
      );
      setRegisterData({
        clientCode: credentials.clientCode,
        cpfCnpj: credentials.cpfCnpj,
      });
      navigate(AppRoutes.REGISTER_FORM);
    } catch (error) {
      if (error.response && error.response.data) {
        const errorMessage =
          error.response.data.details ||
          error.response.data.message ||
          'Erro desconhecido';
        Alert.alert('Erro', String(errorMessage));
      } else {
        Alert.alert('Erro', 'Algo deu errado, por favor tente novamente.');
      }
      console.error(error);
    }
    hideLoading();
  };

  const handleCheck = () => {
    if (!check) {
      Alert.alert('Necessário ser maior de 18 para prosseguir!');
    } else if (!credentials.clientCode || !credentials.cpfCnpj) {
      Alert.alert('Preencha todos os campos!');
    } else {
      handleNavigateRegisterForm();
    }
  };

  return (
    <ImageBackground
      // source={Images.backgroundCoke}
      style={{flex: 1, backgroundColor: '#e61c2b'}}>
      <View style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <View
            style={{
              flexDirection: 'row',
              width: '100%',
              justifyContent: 'center',
            }}>
            <TouchableOpacity
              onPress={goBack}
              style={{position: 'absolute', left: 0, height: 30, width: 30}}>
              <FontAwesome6
                name="arrow-left"
                color={Colors.GrayPallete.lightgrayThree}
                size={22}
              />
            </TouchableOpacity>
            <Image source={Images.ProfileSimbol} style={styles.simbol} />
          </View>
          <View style={styles.containerInput}>
            <Input
              title="Código do cliente"
              keyboardType="numeric"
              placeholder="123456789"
              onChangeText={text =>
                setCredentials({...credentials, clientCode: text})
              }
            />
            <Input
              title="CPF/CNPJ"
              keyboardType="numeric"
              placeholder="CPF/CNPJ..."
              mt={45}
              onChangeText={text =>
                setCredentials({...credentials, cpfCnpj: text})
              }
            />
            <CheckBox
              description="Declaro ser maior de 18 anos."
              mt={20}
              isCheck={check}
              onPress={() => setCheck(!check)}
            />
          </View>
          <View>
            <ButtonComponent title="Próximo" outlined onPress={handleCheck} />
            <TouchableOpacity
              onPress={() => Linking.openURL('tel:08000615000')}>
              <Text style={styles.call}>
                Não tem cadastro com a Brasal Refrigerantes?
              </Text>
              <Text style={styles.number}>Ligue para 0800 061 5000</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
    </ImageBackground>
  );
};

export default RegisterCode;
